import { Component, OnInit, Input, Optional, SimpleChanges, OnChanges } from '@angular/core';
import { layer, style, StyleFunction } from 'openlayers';
import { MapComponent } from '../map.component';
import { LayerComponent } from './layer.component';
import { LayerGroupComponent } from './layergroup.component';
import { Feature } from 'ol';

@Component({
  selector: 'aol-layer-vectortile',
  template: `<ng-content></ng-content>`
})
export class LayerVectorTileComponent extends LayerComponent implements OnInit, OnChanges {
  @Input() renderBuffer: number;
  @Input() renderMode: layer.VectorTileRenderType | string;
  /* not marked as optional in the typings */
  @Input() renderOrder: (feature1: Feature, feature2: Feature) => number;
  @Input() style: style.Style | style.Style[] | StyleFunction;
  @Input() updateWhileAnimating: boolean;
  @Input() updateWhileInteracting: boolean;
  @Input() declare visible: boolean;

  constructor(map: MapComponent, @Optional() group?: LayerGroupComponent) {
    super(group || map);
  }

  override ngOnInit() {
    // @ts-ignore
    this.instance = new layer.VectorTile(this);
    super.ngOnInit();
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }
}
